function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import cx from 'classnames';
import { RecursionField, useField, useForm } from '@formily/react';
import { evalStatement } from '@micun/form-expression';

// @ts-ignore
import { nanoid } from 'nanoid/non-secure';
import React, { useContext, useEffect, useState } from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { genListFieldStyles } from "./styles";
import { Button } from 'antd';
import { ScopeContext } from '@micun/form-expression/react/index';
export var ListField = wrapReactionHook(function (props) {
  var children = props.children;
  var schema = props.schema,
    _props$editable = props.editable,
    editable = _props$editable === void 0 ? false : _props$editable,
    _props$showPartingLin = props.showPartingLine,
    showPartingLine = _props$showPartingLin === void 0 ? false : _props$showPartingLin,
    _props$showAdd = props.showAdd,
    showAdd = _props$showAdd === void 0 ? true : _props$showAdd,
    _props$showDelete = props.showDelete,
    showDelete = _props$showDelete === void 0 ? true : _props$showDelete,
    defaultAddLength = props.defaultAddLength;
  var field = useField();
  var form = useForm();
  var _useContext = useContext(ScopeContext),
    scope = _useContext.scope;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    deleteId = _useState2[0],
    setDeleteId = _useState2[1];
  var prefix = 'form-list-field';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genListFieldStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  if (!schema) {
    return;
  }
  useEffect(function () {
    // 默认添加几个数据的逻辑
    if (defaultAddLength && Array.isArray(field.value) && field.value.length === 0) {
      var i = 0;
      while (i < defaultAddLength) {
        field.push({
          __id__: nanoid()
        });
        i++;
      }
    }
    if (defaultAddLength && !field.value) {
      field.value = [];
      var _i = 0;
      while (_i < defaultAddLength) {
        field.push({
          __id__: nanoid()
        });
        _i++;
      }
    }
  }, []);
  var renderItemSchema = function renderItemSchema(item, index) {
    var newSchema = _objectSpread({}, schema);
    var context = _objectSpread(_objectSpread({}, form.values), {}, {
      index: index,
      item: item,
      self: item,
      schema: newSchema
    });
    Object.keys(newSchema).forEach(function (key) {
      var statement = schema[key];
      var statements = Array.isArray(statement) ? statement : [statement];
      var result = evalStatement(statements, {
        context: context,
        parentScope: scope
      });
      // console.log('key', key, result, statements)
      newSchema[key] = result;
    });
    return newSchema;
  };
  var getResult = function getResult(value, item, index) {
    if (typeof value === 'boolean') {
      return value;
    }
    return evalStatement(Array.isArray(value) ? value : [value], {
      context: {
        item: item,
        index: index
      },
      parentScope: scope
    });
  };
  var len = Array.isArray(field.value) ? field.value.length : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, prefix)
  }, Array.isArray(field.value) ? field.value.map(function (item, index) {
    var newSchema = renderItemSchema(item, index);
    // console.log('list item', item, index, newSchema)
    var key = item.__id__ ? "".concat(field.editable, "_").concat(item.__id__) : undefined;
    return editable ? /*#__PURE__*/React.createElement("div", {
      className: cx(hashId, showPartingLine && index !== 0 ? 'itemPadding' : null, showPartingLine && len !== index + 1 ? 'item' : 'itemLast', item.__id__ && item.__id__ === deleteId ? 'onDelete' : ''),
      key: key
    }, field.editable && getResult(showDelete, item, index) ? /*#__PURE__*/React.createElement("span", {
      className: 'iconDelete',
      onClick: function onClick() {
        if (item.__id__) {
          setDeleteId(item.__id__);
          setTimeout(function () {
            setDeleteId(undefined);
            field.remove(index);
          }, 300);
        } else {
          field.remove(index);
        }
      }
    }) : null, /*#__PURE__*/React.createElement(RecursionField, {
      schema: newSchema
      // 兼容两种版本的schema结构配置
      // schema中配置了 name 字段则使用精确到 name 的字段，用于动态渲染单个可交互字段
      // 否则使用index直接渲染完全定义的schema，用于渲染任意的子字段
      ,
      name: newSchema.name ? [index, schema.name] : index
    })) : /*#__PURE__*/React.createElement(RecursionField, {
      schema: newSchema
      // 兼容两种版本的schema结构配置
      // schema中配置了 name 字段则使用精确到 name 的字段，用于动态渲染单个可交互字段
      // 否则使用index直接渲染完全定义的schema，用于渲染任意的子字段
      ,
      name: newSchema.name ? [index, schema.name] : index
    });
  }) : null, field.editable && editable && showAdd ? /*#__PURE__*/React.createElement(Button, {
    block: true,
    className: cx(hashId, "".concat(prefix, "-add")),
    onClick: function onClick() {
      if (!Array.isArray(field.value)) {
        field.value = [];
      }
      field.push({
        __id__: nanoid()
      });
    }
  }, "\u589E\u52A0") : null);
});